<template>
  <transition name="modal">
    <div class="modal-mask" @click="$emit('close')">
      <div class="modal-wrapper">
        <div class="modal-container" v-on:click.stop>
          <div class="modal-body">
            <slot/>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'ModalLightbox',
    props: {
      back: {
        type: String,
        default: '/'
      }
    }
  }
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .85);
  display: table;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
  padding: 1em;
}

.modal-container {
  max-width: 300px;
  margin: 0px auto;
  padding: 27px 22px;
  background-color: #fff;
  border-radius: 12px;
  transition: all .25s ease;
}

.modal-enter, .modal-leave-to {
  opacity: 0;
}

.modal-enter-to, .modal-leave {
  opacity: 1;
}

.modal-enter-active, .modal-leave-active  {
  transition: opacity .25s ease;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
